module.exports = __webpack_public_path__ + "img/vue1-milieu_noir.14d8b3ca.png";